import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../common/ConfirmModal';
import { deleteIndexedData, deleteData } from 'store/idb';
import { useUsersListSnapshot, setUsersListLoaded, getCurrentUserId } from 'store/storeValtio';
import { setUserStateLoaded, setMedsLoaded, setMedsHistoryLoaded, setConditionsLoaded } from 'store/storeValtio';
import HelpTitle from '../common/HelpTitle';
import Spinner from '../spinner/Spinner';
import './users.css';

export default function DeleteUser() {
  const [userToDelete, setUserToDelete] = useState(0);
  const currentUserId = getCurrentUserId();
  const uls = useUsersListSnapshot();
  const usersLoaded = uls.loaded;
  const usersList = uls.usersList;
  const navigate = useNavigate(); 
  const [popup, setPopup] = useState({
    show: false,
    userName: 'tempName',
    id: null,
  });
  console.log('DeleteUser', currentUserId, usersList);

  const handleDelete = (e) => {
    //console.log('handleDelete', e);
    let ix = parseInt(e.target.id);
    const user = usersList[ix];
    const uid = user.userId;
    setUserToDelete(uid);
    //console.log('handleDelete', ix, user);
    if (currentUserId === uid)
    {
      setPopup({ 
        show: true, 
        confirm: null,
        userName: 'You cannot delete the current user!',
        content: '',
        id: 0 });
  
    } else {
    setPopup({ 
      show: true, 
      confirm: 'Delete',
      userName: user.displayName,
      content: 'Do you really want to delete this user?',
      id: uid });
    }
    //setIsOpen(true);

  };

  // This will perform the deletion and hide the Confirmation Box

  const handleDeleteTrue = () => {
    //console.log('handleDeleteTrue', popup.id);
    handleDeleteUser(popup.id);
  };

  // This will just hide the Confirmation Box when user clicks "No"/"Cancel"

  const handleDeleteFalse = () => {
    //console.log('handleDeleteFalse');
    setPopup({ show: false, taken: null, id: null });
  };

  function handleDeleteUser() {
    //console.log('handleDeleteUser', userToDelete);
    deleteIndexedData('medications', 'user', userToDelete );
    deleteIndexedData('history', 'user', userToDelete );
    deleteIndexedData('conditions', 'user', userToDelete );
    deleteData('users', userToDelete)

    setMedsLoaded(false);
    setMedsHistoryLoaded(false);
    setConditionsLoaded(false);
    setUserStateLoaded(false);
    setUsersListLoaded(false);
    navigate('/');
  }


  if (!usersLoaded) return <Spinner />;

  return (
    <div className='pt-8 h-full flex flex-col justify-normal items-center text-center font-bold text-2xl bg-blue-200 '>
      <ConfirmModal
        open={popup.show}
        confirmButton={popup.confirm}
        onConfirm={() => handleDeleteTrue()}
        onCancel={() => handleDeleteFalse()}
        title={popup.userName}
        content={popup.content}
      />

      <HelpTitle title="Delete User" helpSubject="DeleteUser" />

      <div className='mt-4 mx-auto w-full max-w-md'>
        <div className='changeUser py-8'>
          <ul className='flex flex-col items-center'>
            {usersList.map((u, ix) => {
              //console.log("ul", ix, u);
              return (
                <li key={ix}
                  className={`${currentUserId === u.userId ? 'bg-red-300' : ''}`}
                  id={ix}
                  onClick={handleDelete}
                >
                  {u.displayName}
                </li>
              )
            })
            }
          </ul>
        </div>
      </div>
    </div>
);
}

